import React from 'react';
import {  useForm } from 'react-hook-form';
import AppFormInput from '../../../../components/form/app-form-input';
import Button from '../../../../components/button';
import './add-merchant.part.form.scss';
import { apiService } from '../../../../services/api.service';
import { useNavigate } from 'react-router-dom';
import { errorService } from '../../../../services/error.service';


export interface AddMerchantForm {
    name: string;
    merchantEmail: string;
    merchantPassword: string;
}




const AddMerchantPartForm: React.FC = () => {
    const navigate = useNavigate();
    const form = useForm<AddMerchantForm>({
        defaultValues: {
         
        },
    });

    const onCreateMerchant = async (data: AddMerchantForm) => {
        const transformedData = {
                lastName: data.name,
                userName: data.name,
                email: data.merchantEmail,
                password: data.merchantPassword,
        };

        try {
            await apiService.createMerchant(transformedData);
            errorService.showSuccess('Success', `Merchant ${data.name} has been added!`)
            navigate(-1);
        } catch (error: any) {
            errorService.showApiError(error)
        }
    }


    return (
        <div className="add-merchant-form flex-column flex-gap-30">
            <div className="flex-column flex-gap-15">
                <span className="label">General information</span>
                <div className="flex-row flex-gap-20">
                    <AppFormInput
                        control={form.control}
                        name="name"
                        placeholder="Name"
                        validations={{ required: true }}
                    />
                    <AppFormInput
                        control={form.control}
                        type="email"
                        name="merchantEmail"
                        placeholder="Email Merchant ADMIN"
                        validations={{ required: true }}
                    />
                    <AppFormInput
                        control={form.control}
                        name="merchantPassword"
                        type="password"
                        placeholder="Password Merchant ADMIN"
                        validations={{ required: true }}
                    />
                </div>
            </div>

         


            <div className='flex-row flex-align-end-end flex-gap-40'>
                <Button
                    label='Cancel'
                    theme='secondary'
                    onClick={() => navigate(-1)}
                />
                <Button
                    label='Save'
                    disabled={!form.formState.isValid}
                    onClick={form.handleSubmit(onCreateMerchant)}
                />
            </div>
        </div>
    );
};

export default AddMerchantPartForm